/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Template/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import BackAction from './BackAction/index'
import CancelAction from './CancelAction/index'
import Location from './Location/index'
import Name from './Name/index'
import Note from './Note/index'
import NoteEditor from './NoteEditor/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Tags from './Tags/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Template({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Template"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let noteTemplatesTabNoteTemplateIdValueData = fromData.useDataValue({ viewPath,
context: 'note_templates_tab',
path: 'note_template.id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Template.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1tLtd3': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z1tLtd3': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-Z1tLtd3': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-Z1tLtd3': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text={noteTemplatesTabNoteTemplateIdValueData ? "Edit note template" : "Add new note template"}
 marginTop={dtSpaceXs}
 level="h2"
 data="note_templates_tab.note_template.id"
/>
<div
  data-testid="Template.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Create templates for notes to speed up note taking experience in appointment notes, treatment notes."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<div
  data-testid="Template.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
<Note
  viewPath={`${viewPath}/Note`}
/>
<NoteEditor
  viewPath={`${viewPath}/NoteEditor`}
/>
</div>
<div
  data-testid="Template.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-5-Z1tLtd3': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}